import d, { forwardRef as w } from "react";
import { P as _ } from "./index-CZzwT3Oj.mjs";
import './assets/Form.css';function f() {
  return f = Object.assign || function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var i = arguments[n];
      for (var e in i)
        Object.prototype.hasOwnProperty.call(i, e) && (t[e] = i[e]);
    }
    return t;
  }, f.apply(this, arguments);
}
function h(t, n) {
  if (t == null) return {};
  var i = s(t, n), e, r;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (r = 0; r < o.length; r++)
      e = o[r], !(n.indexOf(e) >= 0) && Object.prototype.propertyIsEnumerable.call(t, e) && (i[e] = t[e]);
  }
  return i;
}
function s(t, n) {
  if (t == null) return {};
  var i = {}, e = Object.keys(t), r, o;
  for (o = 0; o < e.length; o++)
    r = e[o], !(n.indexOf(r) >= 0) && (i[r] = t[r]);
  return i;
}
var a = w(function(t, n) {
  var i = t.color, e = i === void 0 ? "currentColor" : i, r = t.size, o = r === void 0 ? 24 : r, l = h(t, ["color", "size"]);
  return /* @__PURE__ */ d.createElement("svg", f({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: e,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, l), /* @__PURE__ */ d.createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  }), /* @__PURE__ */ d.createElement("line", {
    x1: "12",
    y1: "9",
    x2: "12",
    y2: "13"
  }), /* @__PURE__ */ d.createElement("line", {
    x1: "12",
    y1: "17",
    x2: "12.01",
    y2: "17"
  }));
});
a.propTypes = {
  color: _.string,
  size: _.oneOfType([_.string, _.number])
};
a.displayName = "AlertTriangle";
function p() {
  return p = Object.assign || function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var i = arguments[n];
      for (var e in i)
        Object.prototype.hasOwnProperty.call(i, e) && (t[e] = i[e]);
    }
    return t;
  }, p.apply(this, arguments);
}
function g(t, n) {
  if (t == null) return {};
  var i = c(t, n), e, r;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (r = 0; r < o.length; r++)
      e = o[r], !(n.indexOf(e) >= 0) && Object.prototype.propertyIsEnumerable.call(t, e) && (i[e] = t[e]);
  }
  return i;
}
function c(t, n) {
  if (t == null) return {};
  var i = {}, e = Object.keys(t), r, o;
  for (o = 0; o < e.length; o++)
    r = e[o], !(n.indexOf(r) >= 0) && (i[r] = t[r]);
  return i;
}
var u = w(function(t, n) {
  var i = t.color, e = i === void 0 ? "currentColor" : i, r = t.size, o = r === void 0 ? 24 : r, l = g(t, ["color", "size"]);
  return /* @__PURE__ */ d.createElement("svg", p({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: e,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, l), /* @__PURE__ */ d.createElement("path", {
    d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
  }), /* @__PURE__ */ d.createElement("polyline", {
    points: "22 4 12 14.01 9 11.01"
  }));
});
u.propTypes = {
  color: _.string,
  size: _.oneOfType([_.string, _.number])
};
u.displayName = "CheckCircle";
const m = "_form_wz4dg_1", z = "_fieldset_wz4dg_11", v = "_form__row_wz4dg_187", O = {
  form: m,
  fieldset: z,
  "form-field": "_form-field_wz4dg_28",
  "form-field__icon": "_form-field__icon_wz4dg_37",
  "form-field--checkbox": "_form-field--checkbox_wz4dg_45",
  "form-field--select": "_form-field--select_wz4dg_54",
  "form-field__icon--invalid": "_form-field__icon--invalid_wz4dg_59",
  "form-field__label": "_form-field__label_wz4dg_63",
  "form-field__label-help": "_form-field__label-help_wz4dg_72",
  "form-field__label--checkbox": "_form-field__label--checkbox_wz4dg_77",
  "form-field__input": "_form-field__input_wz4dg_82",
  "form-field__error-message": "_form-field__error-message_wz4dg_150",
  "input--touched": "_input--touched_wz4dg_173",
  form__row: v,
  "input-width--10": "_input-width--10_wz4dg_194",
  "input-width--15": "_input-width--15_wz4dg_198",
  "input-width--20": "_input-width--20_wz4dg_202",
  "input-width--25": "_input-width--25_wz4dg_206",
  "input-width--30": "_input-width--30_wz4dg_210",
  "input-width--35": "_input-width--35_wz4dg_214",
  "input-width--33": "_input-width--33_wz4dg_218",
  "input-width--40": "_input-width--40_wz4dg_222",
  "input-width--50": "_input-width--50_wz4dg_226",
  "input-width--60": "_input-width--60_wz4dg_230",
  "input-width--66": "_input-width--66_wz4dg_234",
  "input-width--70": "_input-width--70_wz4dg_238",
  "input-width--75": "_input-width--75_wz4dg_242",
  "input-width--80": "_input-width--80_wz4dg_246",
  "input-width--85": "_input-width--85_wz4dg_250",
  "input-width--90": "_input-width--90_wz4dg_254",
  "input-width--100": "_input-width--100_wz4dg_258"
};
export {
  a as A,
  u as C,
  O as s
};
